/* HAND-AUTHORED (the artifact pipeline was unavailable for this scene) — film scene "f-monitor".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { FilmScene } from '../../types';

export const F_MONITOR: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "req",
      "x": 14,
      "y": 16,
      "w": 152,
      "h": 268,
      "lKey": "films:f-monitor.items.req.l"
    },
    {
      "k": "box",
      "id": "run",
      "x": 26,
      "y": 48,
      "w": 128,
      "h": 48,
      "lKey": "films:f-monitor.items.run.l"
    },
    {
      "k": "frame",
      "id": "svc",
      "x": 178,
      "y": 16,
      "w": 152,
      "h": 268,
      "lKey": "films:f-monitor.items.svc.l"
    },
    {
      "k": "box",
      "id": "s1",
      "x": 190,
      "y": 48,
      "w": 128,
      "h": 40,
      "lKey": "films:f-monitor.items.s1.l"
    },
    {
      "k": "box",
      "id": "s2",
      "x": 190,
      "y": 96,
      "w": 128,
      "h": 40,
      "lKey": "films:f-monitor.items.s2.l"
    },
    {
      "k": "box",
      "id": "s3",
      "x": 190,
      "y": 144,
      "w": 128,
      "h": 40,
      "lKey": "films:f-monitor.items.s3.l"
    },
    {
      "k": "wire",
      "id": "wa",
      "from": "run",
      "to": "s1"
    },
    {
      "k": "wire",
      "id": "wb",
      "from": "s1",
      "to": "s2"
    },
    {
      "k": "wire",
      "id": "wc",
      "from": "s2",
      "to": "s3"
    },
    {
      "k": "frame",
      "id": "met",
      "x": 342,
      "y": 16,
      "w": 130,
      "h": 268,
      "lKey": "films:f-monitor.items.met.l"
    },
    {
      "k": "bar",
      "id": "sli",
      "x": 354,
      "y": 48,
      "w": 106,
      "h": 14,
      "v": 0.96,
      "lKey": "films:f-monitor.items.sli.l"
    },
    {
      "k": "bar",
      "id": "budget",
      "x": 354,
      "y": 106,
      "w": 106,
      "h": 14,
      "v": 0.8,
      "lKey": "films:f-monitor.items.budget.l"
    },
    {
      "k": "spark",
      "id": "p99",
      "x": 354,
      "y": 168,
      "w": 106,
      "h": 50,
      "pts": [4, 5, 5, 6, 5, 5, 9, 14, 22]
    },
    {
      "k": "wire",
      "id": "wd",
      "from": "s3",
      "to": "sli",
      "dash": true
    },
    {
      "k": "chip",
      "id": "alert",
      "x": 486,
      "y": 16,
      "w": 140,
      "h": 38,
      "lKey": "films:f-monitor.items.alert.l"
    },
    {
      "k": "box",
      "id": "human",
      "x": 486,
      "y": 120,
      "w": 140,
      "h": 64,
      "lKey": "films:f-monitor.items.human.l",
      "sKey": "films:f-monitor.items.human.s"
    },
    {
      "k": "wire",
      "id": "we",
      "from": "sli",
      "to": "alert"
    },
    {
      "k": "wire",
      "id": "wf",
      "from": "alert",
      "to": "human"
    }
  ],
  "steps": [
    {
      "on": ["req", "run", "svc", "s1", "s2", "s3", "wa", "wb", "wc"],
      "hot": ["s3", "wc"],
      "capKey": "films:f-monitor.steps.0.cap"
    },
    {
      "on": ["req", "run", "svc", "s1", "s2", "s3", "wa", "wb", "wc", "met", "sli", "wd"],
      "hot": ["sli", "wd"],
      "capKey": "films:f-monitor.steps.1.cap"
    },
    {
      "on": ["req", "run", "svc", "s1", "s2", "s3", "wa", "wb", "wc", "met", "sli", "wd", "budget"],
      "hot": ["budget"],
      "capKey": "films:f-monitor.steps.2.cap"
    },
    {
      "on": ["req", "run", "svc", "s1", "s2", "s3", "wa", "wb", "wc", "met", "sli", "wd", "budget", "p99", "alert", "we"],
      "hot": ["p99", "alert", "we"],
      "capKey": "films:f-monitor.steps.3.cap"
    },
    {
      "on": ["req", "run", "svc", "s1", "s2", "s3", "wa", "wb", "wc", "met", "sli", "wd", "budget", "p99", "alert", "we", "human", "wf"],
      "hot": ["human", "wf"],
      "capKey": "films:f-monitor.steps.4.cap"
    }
  ]
};